import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, ArrowRight } from 'lucide-react';
import { useAppContext } from '../contexts/AppContext';
import { toast } from 'sonner';
import { BillvastLogo } from '../components/ui/BillvastLogo';
export const Login: React.FC = () => {
  const [email, setEmail] = useState('demo@billvast.com');
  const [password, setPassword] = useState('password123');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const {
    login
  } = useAppContext();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      login();
      toast.success('Welcome back to Billvast!');
      navigate('/dashboard');
    }, 1000);
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-748">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-749">
        <div className="flex justify-center" data-id="element-750">
          <BillvastLogo size="xl" data-id="element-751" />
        </div>
        <p className="mt-4 text-center text-sm text-brand-text-light" data-id="element-752">
          Powering Africa's Digital Economy
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-753">
        <div className="bg-white py-8 px-4 shadow-xl shadow-gray-200/50 sm:rounded-2xl sm:px-10 border border-gray-100" data-id="element-754">
          <form className="space-y-6" onSubmit={handleLogin} data-id="element-755">
            <div data-id="element-756">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-757">
                Email address
              </label>
              <div className="mt-1" data-id="element-758">
                <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="appearance-none block w-full px-3 py-2.5 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm transition-colors" data-id="element-759" />
              </div>
            </div>

            <div data-id="element-760">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-761">
                Password
              </label>
              <div className="mt-1" data-id="element-762">
                <input id="password" name="password" type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="appearance-none block w-full px-3 py-2.5 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm transition-colors" data-id="element-763" />
              </div>
            </div>

            <div className="flex items-center justify-between" data-id="element-764">
              <div className="flex items-center" data-id="element-765">
                <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-brand-primary focus:ring-brand-primary border-gray-300 rounded" data-id="element-766" />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900" data-id="element-767">
                  Remember me
                </label>
              </div>

              <div className="text-sm" data-id="element-768">
                <a href="#" className="font-medium text-brand-primary hover:text-brand-primary-dark" data-id="element-769">
                  Forgot your password?
                </a>
              </div>
            </div>

            <div data-id="element-770">
              <button type="submit" disabled={isLoading} className="w-full flex justify-center py-3 px-4 border border-transparent rounded-xl shadow-sm text-sm font-medium text-white bg-brand-primary hover:bg-brand-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary transition-colors disabled:opacity-70" data-id="element-771">
                {isLoading ? 'Signing in...' : 'Sign in'}
              </button>
            </div>
          </form>

          <div className="mt-6" data-id="element-772">
            <div className="relative" data-id="element-773">
              <div className="absolute inset-0 flex items-center" data-id="element-774">
                <div className="w-full border-t border-gray-300" data-id="element-775" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-776">
                <span className="px-2 bg-white text-gray-500" data-id="element-777">Demo Access</span>
              </div>
            </div>

            <div className="mt-6" data-id="element-778">
              <button onClick={handleLogin} className="w-full inline-flex justify-center items-center gap-2 py-3 px-4 border border-gray-300 rounded-xl shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-779">
                <Shield size={18} className="text-brand-primary" data-id="element-780" />
                Continue as Demo User
                <ArrowRight size={16} className="text-gray-400 ml-auto" data-id="element-781" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};